import { render, staticRenderFns } from "./Project10Zh.vue?vue&type=template&id=2d76b7f3&scoped=true&"
import script from "./Project10Zh.vue?vue&type=script&lang=js&"
export * from "./Project10Zh.vue?vue&type=script&lang=js&"
import style0 from "./Project10Zh.vue?vue&type=style&index=0&id=2d76b7f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d76b7f3",
  null
  
)

export default component.exports